import { render, staticRenderFns } from "./dynamic-panel-self.vue?vue&type=template&id=4adf057b&scoped=true"
import script from "./dynamic-panel-self.vue?vue&type=script&lang=js"
export * from "./dynamic-panel-self.vue?vue&type=script&lang=js"
import style0 from "./dynamic-panel-self.vue?vue&type=style&index=0&id=4adf057b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4adf057b",
  null
  
)

export default component.exports